const optionWidthsData = [
  {
    Option: 1,
    Sidewalk1: 10,
    CurbExtension1: 6,
    BikeLane: 6,
    SharedLane: 10,
    BusLane: 11,
    ParkingBay: 7,
    CurbExtension2: 0,
    Sidewalk2: 10,
    Total: 60,
    Notes: 'One Way',
  },
  {
    Option: 2,
    Sidewalk1: 10,
    CurbExtension1: 6,
    BikeLane: 0,
    SharedLane: 21,
    BusLane: 0,
    ParkingBay: 7,
    CurbExtension2: 6,
    Sidewalk2: 10,
    Total: 60,
    Note: 'Two Way',
  },
  {
    Option: 3,
    Sidewalk1: 10,
    CurbExtension1: 6,
    BikeLane: 0,
    SharedLane: 10,
    BusLane: 11,
    ParkingBay: 7,
    CurbExtension2: 6,
    Sidewalk2: 10,
    Total: 60,
    Note: 'One Way',
  },
  {
    Option: 4,
    Sidewalk1: 10,
    CurbExtension1: 9,
    BikeLane: 0,
    SharedLane: 10,
    BusLane: 12,
    ParkingBay: 7,
    CurbExtension2: 0,
    Sidewalk2: 12,
    Total: 60,
    Note: 'One Way',
  },
  {
    Option: 5,
    Sidewalk1: 16,
    CurbExtension1: 8.5,
    BikeLane: 0,
    SharedLane: 0,
    BusLane: 11,
    ParkingBay: 8.5,
    CurbExtension2: 0,
    Sidewalk2: 16,
    Total: 60,
    Note: 'One Way',
  },
];

export default optionWidthsData;
